import { createRoutine } from 'redux-saga-routines';

export const authenticatedBootstrapping = createRoutine('AUTHENTICATED_BOOTSTRAPPING');
export const commandCenterLogin = createRoutine('COMMAND_CENTER_LOGIN');
export const commandCenterLogout = createRoutine('COMMAND_CENTER_LOGOUT');
export const firebaseAuthentication = createRoutine('FIREBASE_AUTHENTIATION');
export const firebaseLogin = createRoutine('FIREBASE_LOGIN');
export const firebaseSignout = createRoutine('FIREBASE_SIGNOUT');
export const isAuthenticating = createRoutine('IS_AUTHENTICATING');
export const obtainAnonymousToken = createRoutine('OBTAIN_ANONYMOUS_TOKEN');
export const checkForReauth = createRoutine('CHECK_FOR_REAUTH');
export const reauthModalStatus = createRoutine('REAUTH_MODAL_STATUS');
export const obtainJWT = createRoutine('OBTAIN_JWT');
export const obtainSupplementaryUserInfo = createRoutine('OBTAIN_SUPPLEMENTARY_USER_INFO');
